import getVideoId from 'get-video-id';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import NoSsr from '@material-ui/core/NoSsr';
import { Interweave } from 'interweave';
import CourseItem from '../../../components/CourseItem/CourseItem';
import CircularProgressLoader from '../../../components/CircularProgressLoader/CircularProgressLoader';
import Link from '../../../components/Link/Link';

import {
  getVimeoAppId,
  getWhitelabeledOrganizationSlug,
  hasMedicalLicense,
  isTrial,
} from '../../../helpers/index';
import isLoggedIn from '../../../helpers/checkAuth';

import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import CourseLivestream from '../CourseLivestream/CourseLivestream';

import s from './CourseDetailsContent.scss';
import large from '../../../components/large_screen.scss';

import LessonsListItem from '../../../components/LessonsListItem/LessonsListItem';
import QuizzesListItem from '../../../components/QuizzesListItem/QuizzesListItem';

import messages from './courseDetailsContentMessages';
import CongratulationsModal from '../../lessonDetails/CongratulationsModal/CongratulationsModal';
import * as courseDetailsActions from '../../../actions/courseDetails';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import GoToNextSection from '../../lessonDetails/GoToNextSection/GoToNextSection';
import * as podcastLessonActions from '../../../actions/podcastLesson';

@injectIntl
@withStyles(s)
@withStyles(large)
@connect(
  state => ({
    auth: state.auth,
    lang: state.intl.locale,
    course: state.courseDetails.course,
    error: state.courseDetails.error,
    relatedCourses: state.courseDetails.relatedCourses,
    loadingRelatedCourses: state.courseDetails.loadingRelatedCourses,
    totalRelatedCourses: state.courseDetails.totalRelatedCourses,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    nextPodcastLesson: state.podcastLesson.nextLesson,
  }),
  dispatch =>
    bindActionCreators(
      {
        resetCourse: courseDetailsActions.reset,
        resetLesson: lessonDetailsActions.reset,
        getLessonBySlug: lessonDetailsActions.getLessonBySlug,
        setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
        setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
        setNextPodcastLesson: podcastLessonActions.setNextLesson,
        resetPodcastLesson: podcastLessonActions.reset,
        setPlayPodcastAudio: podcastLessonActions.setPlayPodcastAudio,
      },
      dispatch,
    ),
)
export default class CourseDetailsContent extends React.Component {
  static propTypes = {
    error: PropTypes.object, // eslint-disable-line
    auth: PropTypes.object, // eslint-disable-line
    course: PropTypes.object, // eslint-disable-line
    relatedCourses: PropTypes.array.isRequired, // eslint-disable-line
    totalRelatedCourses: PropTypes.number.isRequired,
    loadingRelatedCourses: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    lang: PropTypes.string.isRequired,
    resetLesson: PropTypes.func.isRequired,
    setNextPodcastLesson: PropTypes.func.isRequired,
    openedPodcastLesson: PropTypes.string,
    nextPodcastLesson: PropTypes.object.isRequired, // eslint-disable-line
    getLessonBySlug: PropTypes.func.isRequired,
    setOpenedPodcastLesson: PropTypes.func.isRequired,
    setIsLoadingPodcastLesson: PropTypes.func.isRequired,
    resetPodcastLesson: PropTypes.func.isRequired,
    setPlayPodcastAudio: PropTypes.func.isRequired,
    searchSessionId: PropTypes.string,
  };

  static defaultProps = {
    openedPodcastLesson: '',
    searchSessionId: '',
  };

  static contextTypes = {
    cloudfrontUrl: PropTypes.string,
    fetch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const timeLeft =
      props.course.type === 'livestream' ? this.getTimeLeft(props) : 0;

    this.state = {
      timeLeft,
      isCongratulationsModalOpened: false,
      goToNextSectionItemProgress: 0,
    };

    if (props.course.type === 'livestream') {
      const video = getVideoId(props.course.youtubeVideoUrl);
      this.state.videoId = video.id;
      this.state.videoService = video.service;

      this.state.videoAppId =
        this.state.videoService !== 'vimeo'
          ? ''
          : getVimeoAppId(props.course.youtubeVideoUrl);
    }

    this.timer = null;
  }

  async componentDidMount() {
    if (this.props.course.type === 'livestream') {
      this.timer = setInterval(this.countDown, 1000);
    }
    if (
      _.get(this, 'props.course.type') === 'podcast' &&
      this.props.course.totalLessons === 1
    ) {
      this.getFirstPodcastLesson();
    }

    this.trackGACourseView();
    this.logSearchSessionCourseOpened();
  }

  componentDidUpdate(prevProps) {
    if (_.get(this, 'props.course.type') === 'podcast') {
      if (
        _.get(this, 'props.course._id') === _.get(prevProps, 'course._id') &&
        _.get(this, 'props.course.progress') === 100 &&
        _.get(prevProps, 'course.progress') !== 100
      ) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isCongratulationsModalOpened: true,
        });
      }

      if (
        !_.get(this, 'props.nextPodcastLesson.item._id') &&
        _.get(prevProps, 'nextPodcastLesson.item._id') &&
        this.state.goToNextSectionItemProgress
      ) {
        this.cancelGoToNextSectionItem();
      }

      if (
        _.get(this, 'props.course._id') !== _.get(prevProps, 'course._id') &&
        this.props.course.totalLessons === 1
      ) {
        this.cancelGoToNextSectionItem();
        this.props.setOpenedPodcastLesson(null);
        this.getFirstPodcastLesson();
      }

      if (
        _.get(this, 'props.course._id') !== _.get(prevProps, 'course._id') &&
        this.props.course.totalLessons !== 1
      ) {
        this.props.setOpenedPodcastLesson(null);
      }
    }
  }

  componentWillUnmount() {
    const { course } = this.props;
    if (course.type === 'livestream' && this.timer) {
      clearInterval(this.countDown);
    }
    if (course.type === 'podcast') {
      this.props.resetLesson();
      this.cancelGoToNextSectionItem();
      this.props.resetPodcastLesson();
    }
  }

  getFirstPodcastLesson = async () => {
    const {
      getLessonBySlug,
      setOpenedPodcastLesson,
      course,
      setIsLoadingPodcastLesson,
    } = this.props;
    setIsLoadingPodcastLesson(true);
    setOpenedPodcastLesson(
      _.get(course, 'sections[0].items[0].item._id'),
      false,
    );
    await getLessonBySlug(_.get(course, 'sections[0].items[0].item.slug'), {
      courseId: _.get(course, '_id'),
    });
    setIsLoadingPodcastLesson(false);
  };

  getTimeLeft = props => {
    const timeDifference = moment
      .utc()
      .diff(moment.utc(props.auth.currentTime), 'seconds');
    const end = moment.utc(props.course.liveStreamStart).format('X');
    return end - moment.utc().format('X') + timeDifference;
  };

  countDown = () => {
    const timeLeft = this.getTimeLeft(this.props);
    this.setState({
      timeLeft,
    });
    if (this.timer && timeLeft <= 0) {
      clearInterval(this.timer);
    }
  };

  closeCongratulationsModal = () => {
    this.setState({
      isCongratulationsModalOpened: false,
    });
  };

  goToNextPodcastLesson = lesson => {
    const { course, setNextPodcastLesson, setPlayPodcastAudio } = this.props;
    const {
      goToNextSectionItemProgress: stateGoToNextSectionItemProgress,
    } = this.state;
    const lessonsAndQuizzes = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    const lessonIndex = _.findIndex(
      lessonsAndQuizzes,
      item => item.item._id === _.get(lesson, '_id'),
    );

    if (lessonsAndQuizzes.length - 1 === lessonIndex) {
      return;
    }

    if (
      (_.get(lessonsAndQuizzes[lessonIndex], 'isCompleted') === false &&
        _.subtract(
          _.get(course, 'totalLessons'),
          _.get(course, 'completedLessons'),
        ) === 1) ||
      stateGoToNextSectionItemProgress !== 0
    ) {
      return;
    }

    const nextItem = lessonsAndQuizzes[lessonIndex + 1];
    setNextPodcastLesson(nextItem);
    setPlayPodcastAudio(false);

    const timeout = 7000; // todo move it to config
    const startTs = Date.now();
    this.invervalTimer = setInterval(() => {
      const goToNextSectionItemProgress =
        ((Date.now() - startTs) / timeout) * 100;

      if (goToNextSectionItemProgress > 100) {
        clearInterval(this.invervalTimer);
        return;
      }

      this.setState({
        goToNextSectionItemProgress,
      });
    }, 20);

    this.timeoutTimer = setTimeout(async () => {
      await this.loadNextItem();
    }, timeout);
  };

  cancelGoToNextSectionItem = () => {
    clearTimeout(this.timeoutTimer);
    clearInterval(this.invervalTimer);
    this.setState({
      goToNextSectionItemProgress: 0,
    });
  };

  loadNextItem = async () => {
    const {
      course,
      getLessonBySlug,
      setOpenedPodcastLesson,
      setIsLoadingPodcastLesson,
      resetLesson,
      nextPodcastLesson,
    } = this.props;
    this.cancelGoToNextSectionItem();

    resetLesson();
    setIsLoadingPodcastLesson(true);
    setOpenedPodcastLesson(_.get(nextPodcastLesson, 'item._id'), true, true);
    await getLessonBySlug(_.get(nextPodcastLesson, 'item.slug'), {
      courseId: _.get(course, '_id'),
    });
    setIsLoadingPodcastLesson(false);
  };

  logSearchSessionCourseOpened = async () => {
    const { course, searchSessionId, auth } = this.props;
    if (!searchSessionId || !isLoggedIn(auth)) {
      return;
    }
    try {
      await this.context.fetch(
        `/api/courses/search-session/${searchSessionId}/log-item`,
        {
          method: 'PATCH',
          body: JSON.stringify({
            courseIdOpenedBySearch: course?._id,
          }),
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  trackGACourseView = () => {
    const { course, auth } = this.props;

    if (window && window !== undefined) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'course_view',
        organization_slug: getWhitelabeledOrganizationSlug(auth) || null,
        organization_id: auth?.user?.mainGroup?._id || null,
        organization_name: auth?.user?.mainGroup?.name || null,
        is_course_public: course?.isPublic || false,
        course_name: course?.name,
        course_id: course?._id,
      });
    }
  };

  render() {
    const {
      course,
      auth,
      error,
      relatedCourses,
      loadingRelatedCourses,
      intl: { formatMessage },
      openedPodcastLesson,
      nextPodcastLesson,
    } = this.props;

    const {
      timeLeft,
      videoId,
      videoService,
      videoAppId,
      isCongratulationsModalOpened,
      goToNextSectionItemProgress,
    } = this.state;

    const courseItems = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    let nextItem = _.find(
      courseItems,
      ({ item, isCompleted }) =>
        item._id === course.lastAccessItemId && !isCompleted,
    );

    if (!nextItem) {
      nextItem = courseItems.find(item => item.isCompleted === false);
    }

    if (error) {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.loadingWrapper}>
              <Typography gutterBottom color="error">
                {error.error}
              </Typography>
            </div>
          </div>
        </div>
      );
    }

    const renderSection = section => {
      const { completedLessons } = section;

      return (
        <div
          key={section._id}
          className={classNames(s.flex, s.spaceBetween, s.flexWrapOnMobile)}
        >
          {!course.hideSectionTitle ? (
            <Typography className={s.sectionName}>{section.name}</Typography>
          ) : (
            <div />
          )}
          {isLoggedIn(auth) && (
            <Tooltip
              title={formatMessage(messages.completedItemsInSection, {
                completedLessons,
                completedQuizzes: section.completedQuizzes,
                totalLessons: section.totalLessons,
                totalQuizzes: section.totalQuizzes,
              })}
            >
              <Typography className={s.sectionStat}>
                {completedLessons + section.completedQuizzes} /{' '}
                {section.totalLessons + section.totalQuizzes}
              </Typography>
            </Tooltip>
          )}
        </div>
      );
    };

    const renderSectionItems = section => {
      if (section.isContentHidden) {
        return (
          <div className={s.hiddenNote}>
            <Typography>
              <Interweave content={section.hiddenNote} />
            </Typography>
          </div>
        );
      }
      return _(section.items)
        .map(sectionItem => {
          if (sectionItem.itemType === 'Lesson') {
            return (
              <LessonsListItem
                key={`${section._id}_${_.get(sectionItem, 'item._id', '')}`}
                item={_.get(sectionItem, 'item', {})}
                isCompleted={sectionItem.isCompleted}
                course={course}
                showPodcastContent={
                  openedPodcastLesson ===
                  _.get(sectionItem, 'item._id', undefined)
                }
                goToNextPodcastLesson={this.goToNextPodcastLesson}
                cancelGoToNextSectionItem={this.cancelGoToNextSectionItem}
                disabled={
                  course.forcedProgression &&
                  !_.get(sectionItem, 'isCompleted') &&
                  _.get(sectionItem, 'item._id', '') !==
                    _.get(nextItem, 'item._id')
                }
              />
            );
          }

          if (sectionItem.itemType === 'Quiz') {
            return (
              <QuizzesListItem
                disabled={
                  course.forcedProgression &&
                  !_.get(sectionItem, 'isCompleted') &&
                  _.get(sectionItem, 'item._id', '') !==
                    _.get(nextItem, 'item._id')
                }
                key={`${section._id}_${_.get(sectionItem, 'item._id', '')}`}
                item={_.get(sectionItem, 'item', {})}
                isCompleted={sectionItem.isCompleted}
                course={course}
              />
            );
          }

          return null;
        })
        .value();
    };

    let streamingNow = false;

    if (
      course.type === 'livestream' &&
      timeLeft <= 0 &&
      moment(course.liveStreamEnd).diff(moment()) > 0
    ) {
      streamingNow = true;
    }

    return (
      <main
        className={classNames(s.root, {
          [s.livestream]: course.type === 'livestream',
        })}
      >
        <div className={s.container}>
          {course.type === 'livestream' && (
            <CourseLivestream
              streamingNow={streamingNow}
              videoService={videoService}
              videoAppId={videoAppId}
              videoId={videoId}
              timeLeft={timeLeft}
            />
          )}
          <CourseDetailsHeader
            streamingNow={streamingNow}
            timeLeft={timeLeft}
            videoService={videoService}
            videoAppId={videoAppId}
            videoId={videoId}
            getFirstPodcastLesson={this.getFirstPodcastLesson}
            disableContinueToBtn={goToNextSectionItemProgress !== 0}
          />
          {course.type !== 'livestream' && (
            <>
              <section
                className={classNames(s.sectionsBlock, large.generalSection)}
              >
                {_.get(course, 'sections', []).map((section, index) => (
                  <div key={section._id} className={s.sectionBlock}>
                    {(course.type !== 'podcast' ||
                      (course.type === 'podcast' &&
                        course.totalLessons !== 1)) &&
                      renderSection(section, index)}
                    <List component="div" disablePadding>
                      {renderSectionItems(section)}
                    </List>
                  </div>
                ))}
              </section>
              <section
                className={classNames(
                  s.authorsAndRelatedCoursesBlock,
                  large.generalSection,
                )}
              >
                {course && !_.isEmpty(course.authors) && (
                  <div className={s.authorsBlock}>
                    <Typography className={s.title}>
                      <FormattedMessage {...messages.courseAuthorsTitle} />
                    </Typography>
                    <div className={s.authorsList}>
                      {_.get(course, 'authors', []).map(author => (
                        <div key={author._id} className={s.authorItem}>
                          <Avatar
                            className={s.authorItemDetailsAvatar}
                            alt={author.name}
                            src={
                              _.get(author, 'image.path')
                                ? `${this.context.cloudfrontUrl}/${_.get(
                                    author,
                                    'image.path',
                                  )}`
                                : '/icons/noprofilephoto.png'
                            }
                          />
                          <div className={s.authorItemDetails}>
                            <Typography
                              className={s.authorItemDetailsPersonName}
                            >
                              {author.name}
                            </Typography>
                            <Typography
                              className={s.authorItemDetailsPersonPosition}
                            >
                              {author.profession}
                            </Typography>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {!_.isEmpty(relatedCourses) && (
                  <div className={s.relatedCoursesBlock}>
                    <Typography className={s.title}>
                      <FormattedMessage {...messages.relatedCoursesLabel} />
                    </Typography>
                    {loadingRelatedCourses && <CircularProgressLoader />}
                    {!loadingRelatedCourses && (
                      <Grid className={s.gridList} spacing={1} container>
                        {relatedCourses.map(item => (
                          <Grid
                            key={item._id}
                            xs={12}
                            sm={4}
                            md={6}
                            lg={4}
                            className={classNames({
                              [s.relatedCourseListItem]: true,
                              [s.moreItems]: _.isEmpty(course.authors),
                            })}
                            item
                          >
                            <CourseItem item={item} />
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {relatedCourses.length >= 6 && (
                      <div className={s.loadMoreButtonWrapper}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          to="/"
                          component={Link}
                        >
                          <FormattedMessage {...messages.loadMoreBtnLabel} />
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </section>
            </>
          )}
        </div>
        {course._id && (
          <Modal
            open={isCongratulationsModalOpened}
            onClose={this.closeCongratulationsModal}
          >
            <CongratulationsModal
              onClose={this.closeCongratulationsModal}
              course={course}
              hideCertificateBtn={
                hasMedicalLicense(auth.user && auth.user.mainGroup) ||
                !course.assignCertificate ||
                isTrial(auth)
              }
            />
          </Modal>
        )}
        {goToNextSectionItemProgress !== 0 &&
          !isCongratulationsModalOpened &&
          _.get(nextPodcastLesson, '_id') && (
            <NoSsr>
              <GoToNextSection
                nextItem={nextPodcastLesson}
                goToNextSectionItemProgress={goToNextSectionItemProgress}
                cancelGoToNextSectionItem={this.cancelGoToNextSectionItem}
                nextPodcastItemClickHandler={this.loadNextItem}
              />
            </NoSsr>
          )}
      </main>
    );
  }
}
